import React, { useState } from 'react';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import { LinkButton } from '../../../components/common/LinkButton';
import { RentalReturnStep2 } from './returnStep2';

export const RentalReturnStep4 = ({
  selectedReturnData,
  onClickNext,
  onClickPrevious,
  selectedProductList,
}) => {
  const reasonForReturn = selectedReturnData?.selectedOption?.options?.map(
    (o) => {
      const selected = o.options.find((opt) => opt.isSelected);
      return selected?.label;
    }
  );

  const dot = () => {
    return (
      <div
        style={{
          height: 8,
          width: 8,
          marginLeft: 10,
          marginRight: 10,
          borderRadius: 15,
          background: '#2E2B2B',
        }}
      />
    );
  };

  const renderButton = () => {
    return (
      <div className={'review-button'}>
        <ButtonWithLoadingIcon
          style={{
            alignSelf: 'center',
            width: '35%',
            marginBottom: 10,
          }}
          type='submit'
          color={'primary'}
          onClick={() => {
            if (onClickNext) {
              onClickNext();
            }
          }}
        >
          SUBMIT
        </ButtonWithLoadingIcon>
        <LinkButton
          className={'mt-3'}
          style={{
            marginBottom: 10,
            textAlign: 'center',
            width: '100%',
            height: 55,
            cursor: 'pointer',
          }}
          onClick={() => {
            if (onClickPrevious) {
              onClickPrevious(selectedReturnData);
            }
          }}
        >
          Previous
        </LinkButton>
      </div>
    );
  };
  return (
    <div
      style={{
        marginLeft: '2.5rem',
        marginRight: '2.5rem',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {selectedReturnData?.selectedProduct ? (
        <span>{`ITEM${
          selectedProductList?.length > 1 ? 'S' : ''
        } IN RETURN`}</span>
      ) : null}
      {selectedReturnData?.selectedProduct ? (
        <div
          style={{
            marginBottom: 40,
          }}
        >
          <div
            className='d-flex flex-direction-row align-items-center'
            style={{ justifyContent: 'space-between' }}
          >
            <span style={{ fontFamily: 'Brown Bold' }}>
              Order{' '}
              {selectedReturnData?.selectedProduct?.order_number
                ? `#${selectedReturnData?.selectedProduct?.order_number}`
                : '--'}
            </span>
            <span style={{ fontFamily: 'Brown Bold' }}>
              Date ordered: {selectedReturnData?.selectedProduct?.orderDate}
            </span>
          </div>
          <div className='d-flex list-view'>
            {selectedReturnData?.selectedProduct?.img_url ? (
              <div
                className={'mr-3'}
                style={{ height: 170, width: 140, borderRadius: 8 }}
              >
                <img
                  src={selectedReturnData?.selectedProduct?.img_url}
                  alt={selectedReturnData?.selectedProduct?.title}
                  style={{ height: '100%', width: '100%', borderRadius: 8 }}
                />
              </div>
            ) : null}
            <div style={{ marginTop: 8, width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <span style={{ fontFamily: 'Brown', fontSize: 20 }}>
                  {selectedReturnData?.selectedProduct?.brand?.toUpperCase() ||
                    '--'}
                </span>
                <span style={{ fontFamily: 'Brown', fontSize: 20 }}>
                  {selectedReturnData?.selectedProduct?.id}
                </span>
              </div>
              <span
                className='mb-2'
                style={{ fontFamily: 'Brown', fontSize: 20 }}
              >
                {selectedReturnData?.selectedProduct?.title ||
                  selectedReturnData?.selectedProduct?.product_title ||
                  ''}
              </span>
              <br />
              <span>{`${selectedReturnData?.selectedProduct?.size
                ?.toString()
                ?.toUpperCase()}/${selectedReturnData?.selectedProduct?.color?.toUpperCase()}`}</span>
              <div style={{ marginTop: 18 }}>
                {selectedReturnData?.selectedOption?.title ? (
                  <div
                    className={'d-flex flex-direction-row align-items-center'}
                  >
                    <span
                      style={{
                        fontFamily: 'Brown Bold',
                        marginRight: 6,
                        color: '#2E2B2B',
                      }}
                    >
                      Reason for return:
                    </span>
                    <div
                      className={'d-flex flex-direction-row align-items-center'}
                    >
                      <span style={{ marginTop: 2, color: '#2E2B2B' }}>
                        {selectedReturnData?.selectedOption?.title}
                      </span>
                      {reasonForReturn?.length > 0
                        ? reasonForReturn
                            .filter((reason) => reason)
                            .map((r) => (
                              <div
                                className={
                                  'd-flex flex-direction-row align-items-center'
                                }
                              >
                                {dot()}
                                <span
                                  style={{ marginTop: 2, color: '#2E2B2B' }}
                                >
                                  {r}
                                </span>
                              </div>
                            ))
                        : null}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='d-flex align-items-center justify-content-center h-100'>
          No product found for return
        </div>
      )}
      <span
        style={{ fontFamily: 'Brown Bold', marginBottom: 15, color: '#2E2B2B' }}
      >
        RETURN METHOD
      </span>
      <span style={{ marginBottom: 10, color: '#2E2B2B' }}>
        {selectedReturnData?.selectedMethod?.title}{' '}
      </span>
      {selectedReturnData?.selectedMethod?.isPickup ? (
        <span style={{ marginBottom: 10, color: '#7c7571' }}>
          live in an apartment
        </span>
      ) : null}
      {selectedReturnData?.selectedMethod?.isPickup ? (
        <span style={{ marginBottom: 10, color: '#7c7571' }}>
          (207) 123-4567
        </span>
      ) : null}
      {selectedReturnData?.selectedMethod?.isPickup ? (
        <span style={{ marginBottom: 10, color: '#7c7571' }}>No notes</span>
      ) : null}
      {renderButton()}
    </div>
  );
};
